import { DC_HELP_VIDEO, DC_HELP_VIDEO_SLOT, type DcHelpVideoKey } from "pages/DesignStudioPage/toolHelpVideos";
import { PS_HELP_VIDEO, PS_HELP_VIDEO_SLOT } from "components/EditDesign/toolHelpVideos";

/**
 * The backoffice "Site Görselleri" slot of a tool help clip, looked up by the url the call site passed as
 * `Tooltip`'s `video` (always one of `DC_HELP_VIDEO` / `PS_HELP_VIDEO`). Keyed by the SAME constants, so a url
 * is never written twice; an unknown url (a test's, a future clip without a slot) has no slot and plays as given.
 */
const SLOT_BY_URL = new Map<string, string>([
  ...(Object.keys(DC_HELP_VIDEO) as DcHelpVideoKey[]).map((key): [string, string] => [DC_HELP_VIDEO[key], DC_HELP_VIDEO_SLOT[key]]),
  ...(Object.keys(PS_HELP_VIDEO) as (keyof typeof PS_HELP_VIDEO)[]).map((key): [string, string] => [PS_HELP_VIDEO[key], PS_HELP_VIDEO_SLOT[key]]),
]);

export const helpVideoSlotKey = (url: string | undefined): string | undefined => (url ? SLOT_BY_URL.get(url) : undefined);
